import { styled } from 'styled-components';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var ButtonGroupContainer = styled.div.withConfig({
  displayName: "ButtonGroupContainer",
  componentId: "sc-ur0mex-0"
})(["z-index:0;position:relative;display:flex;white-space:nowrap;", " & > *{position:relative;&:not(:first-of-type){margin-left:-", ";border-top-left-radius:0;border-bottom-left-radius:0;}&:not(:last-of-type){border-top-right-radius:0;border-bottom-right-radius:0;}&:focus-visible,&:active{z-index:2;}}"], function (props) {
  return props.$stretch && 'width: 100%;';
}, pxToRem(1));

export { ButtonGroupContainer };
